import React from 'react'
import { Box, SxProps, Typography } from '@mui/material'

import Image from '@components/Image'

export type OurLogosProps = {
  data: {
    ourlogotitle: string
    title_alignment: string
    outlogoimage: { _key: string; asset: { _ref: string } }[]
    logos_per_row: string
  }
  customHeaderText: string
  logosToShow?: 'all' | number
  sx?: SxProps
}

export const OurLogos = ({
  data,
  customHeaderText,
  logosToShow,
  sx,
}: OurLogosProps) => (
  <Box
    sx={{
      maxWidth: 1152,
      mb: { xs: 4, mobile: 5.5, laptop: 8 },
      mt: { xs: 2, mobile: 3, laptop: 5 },
      mx: 'auto',
      ...sx,
    }}>
    <Typography
      variant='h3'
      sx={{
        fontSize: { xs: 24, laptop: 36 },
        px: 4,
        textAlign: data.title_alignment || 'center',
      }}>
      {customHeaderText || data?.ourlogotitle}
    </Typography>

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        mt: { xs: 4, mobile: 5.5, laptop: 8 },
        px: 2,
      }}>
      {data.outlogoimage
        ?.slice(
          0,
          !logosToShow || logosToShow === 'all'
            ? data.outlogoimage.length
            : logosToShow
        )
        .map(item => (
          <Box
            key={item._key}
            sx={{
              width: {
                xs: '33%',
                mobile: `calc(100% / ${data.logos_per_row || 6})`,
              },
              display: 'flex',
              justifyContent: 'center',
              px: 2,
              py: 2,
              img: { objectFit: 'contain' },
            }}>
            <Image props={item.asset?._ref} width='210' height='40' />
          </Box>
        ))}
    </Box>
  </Box>
)
